import { createFileRoute } from '@tanstack/react-router'

import { BrandingSettings } from '@/widgets/branding-settings'

export const Route = createFileRoute('/_app/settings/branding')({
  component: RouteComponent,
})

export const BrandingSettingsRoute = Route

function RouteComponent() {
  return <BrandingSettings />
}
